import { observer } from 'mobx-react'
import React from 'react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import SurveyUpdateWarnings from '../../SurveyUpdateWarnings'

const InheritanceWarningModal = ({ store, onClose, confirm }) => (
    <Modal
        show={store.showInheritanceWarning}
        onClose={onClose}
    >
        <ModalHeader>
            <div>
                <h3 style={{ textAlign: 'center' }}>
                    {i18n.t('inheritanceWarningModal.title')}
                </h3>

                <br />

                <p>
                    {i18n.t('inheritanceWarningModal.body')}
                </p>
                <SurveyUpdateWarnings warnings={store.surveyUpdateWarnings} />
            </div>
        </ModalHeader>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20 }}>
            <Button
                cssClass="regular tertiary"
                onClick={onClose}
                label={i18n.t('cancel')}
            />

            <Button
                cssClass="regular primary"
                onClick={confirm}
                label={i18n.t('inheritanceWarningModal.confirm')}
            />
        </div>
    </Modal>
)

export default observer(InheritanceWarningModal)
